var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h2',[_vm._v("Nie znaleziono strony pasującej do podanego adresu.")]),_c('v-btn',{staticClass:"secondary mt-6",on:{"click":function($event){return _vm.$router.push('/strona-glowna')}}},[_vm._v("Wróć na stronę główną")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }